<template>
  <div class="page-con">
    <div>
      <div class="page-con-header clearfix">
        <vxe-button status="primary" icon="fa fa-save" @click="CreateBalance()"
                    v-if="isHavePermission('balance2:create')">新建期初余额
        </vxe-button>
        <vxe-button icon="vxe-icon--refresh" @click="getListData"
        >刷新
        </vxe-button>
      </div>
      <div
          class="finance-header"
          style="display: flex; flex-wrap: wrap; padding-bottom: 10px"
      >
        <span class="finance-span">
          <label>期初余额类型</label>
          <vxe-select
              v-model="balanceType"
              :options="balanceTypeOptions"
              placeholder="全部"
              style="width: 140px"
          ></vxe-select>
        </span>
        <span class="finance-span">
          <label>所属公司</label>
          <Select
              v-model="searchCompName"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="
              (file) =>
                remoteMethod(
                  file,
                  'compNameOptions',
                  'initBalance',
                  'queryParamCompanyName',
                  7
                )
            "
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="
              (file) => setDefaultOptions(file, 'compNameOptions')
            "
              placeholder="输入所属公司"
          >
            <Option
                v-for="option in compNameOptions"
                :value="option.paramValue"
                :key="option.paramValue"
            >{{ option.paramValue }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>客户</label>
          <Select
              v-model="searchClientName"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="
              (file) =>
                remoteMethod(
                  file,
                  'clientNameOptions',
                  'initBalance',
                  'queryParamClientName',
                  6
                )
            "
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="
              (file) => setDefaultOptions(file, 'clientNameOptions')
            "
              placeholder="输入客户名称"
          >
            <Option
                v-for="option in clientNameOptions"
                :value="option.paramValue"
                :key="option.paramValue"
            >{{ option.paramValue }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>业务员</label>
          <Select
              v-model="searchCompAccount"
              multiple
              filterable
              prefix="ios-arrow-down"
              :remote-method="
              (file) =>
                remoteMethod(
                  file,
                  'compAccountOptions',
                  'initBalance',
                  'queryParamSalesMan',
                  5
                )
            "
              :default-label="[]"
              :loading="searchLoading"
              :max-tag-count="1"
              :max-tag-placeholder="maxTagPlaceholder"
              @on-set-default-options="
              (file) => setDefaultOptions(file, 'compAccountOptions')
            "
              placeholder="请输入业务员"
          >
            <Option
                v-for="(option, index) in compAccountOptions"
                :value="option.paramValue"
                :key="index"
            >{{ option.paramValue }}</Option
            >
          </Select>
        </span>
        <span class="finance-span">
          <label>订单号</label>
          <vxe-input
              v-model="ordersNum"
              placeholder="输入订单编号"
              style="width: 120px"
          ></vxe-input>
        </span>
        <span class="finance-span" style="margin-left: auto">
          <Button
              type="primary"
              icon="ios-search"
              @click="getSearchListKey"
              style="border-radius: 5px"
          >搜索</Button
          >
          <Button @click="reset" style="margin-left: 10px; border-radius: 5px"
          >重置</Button
          >
        </span>
      </div>
    </div>

    <div class="list-box common-shadow">
      <vxe-table
          ref="xTable"
          class="table-style"
          stripe
          import-config
          export-config
          highlight-hover-row
          show-overflow
          show-footer
          max-height="650"
          border="none"
          align="center"
          :loading="loading"
          :data="tableData"
          resizable
          :footer-method="footerMethod"
      >
        <vxe-table-column type="seq" title="序号" align="center" width="90">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
            <Dropdown v-if="isHavePermission('balance2:update') || isHavePermission('balance2:delete')" trigger="click"
                      style="margin-left: 10px;cursor:pointer" transfer>
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left:70px;">
                <div style="display: flex;flex-direction: column;">
                  <Button v-if="isHavePermission('balance2:update')" class="button-gengduo" @click="openEditView(row)">
                    编辑
                  </Button>
                  <Button v-if="isHavePermission('balance2:delete')" class="button-gengduo"
                          @click="commitDelete(row.id)" style="color: #ed4014;">删除
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <!--balanceTypeMap-->
        <vxe-table-column field="type" title="期初余额类型" min-width="140">
          <template slot-scope="{ row }">
            <span>{{ row.type | balanceTypeMap }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
            field="companyName"
            title="所属公司"
            min-width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="ordersNum"
            title="订单编号"
            min-width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="bankName"
            title="开户行"
            min-width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="accountNum"
            title="银行帐号"
            min-width="200"
        ></vxe-table-column>
        <vxe-table-column
            field="clientName"
            title="客户"
            min-width="120"
        ></vxe-table-column>
        <vxe-table-column
            field="salesManName"
            title="业务员"
            min-width="140"
        ></vxe-table-column>
        <vxe-table-column
            field="initBalance"
            title="期初余额"
            min-width="150"
        ></vxe-table-column>
        <vxe-table-column
            field="initTime"
            title="生效时间"
            min-width="150"
        >
          <template slot-scope="{ row }">
            <span>{{ row.initTime | timeFormat }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <vxe-modal
        v-model="isShowAddBalance"
        :title="title"
        width="500"
        height="500"
        resize
        destroy-on-close
    >
      <div class="permissions-main">
        <vxe-form
            ref="xForm"
            class="my-form2"
            title-align="right"
            title-width="140"
            :data="formData"
            :rules="formRules"
            @submit="submitEvent"
            @reset="cancelEvent"
        >
          <vxe-form-item title="期初余额类型" field="type" span="24">
            <template v-slot="scope">
              <vxe-select
                  v-model="formData.type"
                  placeholder="请选择期初余额类型"
                  :options="balanceTypeOptions"
                  clearable
                  @change="$refs.xForm.updateStatus(scope)"
                  @clear="clearType"
              >
              </vxe-select>
            </template>
          </vxe-form-item>
          <vxe-form-item title="所属公司" field="companyName" span="24">
            <template v-slot="scope">
              <vxe-select
                  v-model="formData.companyName"
                  placeholder="请选择所属公司"
                  @change="(file)=>selectCompanyName(file,scope)"
              >
                <vxe-option
                    v-for="(item, index) in dicByParentData"
                    :key="index"
                    :value="item.companyName"
                    :label="item.companyName"
                ></vxe-option>
              </vxe-select>
            </template>
          </vxe-form-item>
          <vxe-form-item title="订单编号" field="ordersNum" span="24">
            <template>
              <vxe-pulldown ref="ordersDown" transfer>
                <template v-slot>
                  <vxe-input v-model="formData.ordersNum" placeholder="请输入订单编号"
                             @input="inputEvent" @blur="checkOrder"></vxe-input>
                </template>
                <template v-slot:dropdown>
                  <div class="chainId-dropdown">
                    <vxe-grid
                        border="none"
                        highlight-hover-row
                        auto-resize
                        height="auto"
                        :loading="ordersLoading"
                        :data="ordersData"
                        :columns="ordersColumns"
                        @cell-click="(file) => cellClick(file,'ordersDown')"
                    ></vxe-grid>
                  </div>
                </template>
              </vxe-pulldown>
            </template>
          </vxe-form-item>
          <vxe-form-item
              title="开户行"
              field="bankName"
              span="24"
              v-if="formData.type == 1"
          >
            <template>
              <div class="sel-text" @click="openBankAccountModal()">
                {{ formData.bankName ? formData.bankName : "选择开户行" }}
              </div>
            </template>
          </vxe-form-item>
          <vxe-form-item
              title="银行账号"
              field="accountNum"
              span="24"
              v-if="formData.type == 1"
          >
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.accountNum"
                  placeholder="自动带出"
                  disabled
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item
              title="客户"
              field="clientName"
              span="24"
              v-if="formData.type !== 1"
          >
            <template>
              <div class="sel-text" @click="openChooseAccount()">
                {{ formData.clientName ? formData.clientName : "选择客户" }}
                <Icon type="md-close" style="margin-left: 10px;color: #c0c4cc;" @click.stop="formData.clientName = null"
                      v-show="formData.clientName"/>
              </div>
            </template>
          </vxe-form-item>
          <vxe-form-item
              title="业务员"
              field="salesManName"
              span="24"
              v-if="formData.type !== 1"
          >
            <template>
              <!-- <div class="sel-text"
             @click="focusEvent('xDown')"
          >{{(formData.salesManName === null || formData.salesManName === '') ? '请选择用户' : formData.salesManName}}</div> -->
              <vxe-pulldown ref="xDown" transfer class="sel-text">
                <template>
                  <div style="display: flex;align-items: center">
                    <div @click="focusEvent('xDown')">
                      {{
                        formData.salesManName === null ||
                        formData.salesManName === ""
                            ? "请选择用户"
                            : formData.salesManName
                      }}
                    </div>
                    <Icon type="md-close" style="margin-left: 10px;color: #c0c4cc;"
                          @click="formData.salesManName = null" v-show="formData.salesManName"/>
                  </div>
                </template>
                <template v-slot:dropdown>
                  <div class="sel-people-dropdown">
                    <Input
                        search
                        v-model="filterName"
                        placeholder="账户名"
                        @on-search="search"
                        style="width: 200px"
                    />
                    <vxe-grid
                        highlight-hover-row
                        auto-resize
                        height="auto"
                        class="table-style-sale"
                        :pager-config="tablePage"
                        :data="tableList"
                        :columns="tableColumn"
                        @cell-click="cellClickEvent"
                        @page-change="pageTableChange"
                    ></vxe-grid>
                  </div>
                </template>
              </vxe-pulldown>
            </template>
          </vxe-form-item>
          <vxe-form-item title="生效时间" field="ordersNum" span="24">
            <template v-slot="scope">
              <vxe-input v-model="formData.initTime" type="date"
                         placeholder="请选择时间" @input="$refs.xForm.updateStatus(scope)" clearable></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item title="期初余额" field="initBalance" span="24">
            <template v-slot="scope">
              <vxe-input
                  v-model="formData.initBalance"
                  placeholder="请输入期初余额"
                  clearable
                  type="float"
                  :digits="2"
                  @input="$refs.xForm.updateStatus(scope)"
              ></vxe-input>
            </template>
          </vxe-form-item>
          <vxe-form-item align="center" span="24">
            <template v-slot>
              <vxe-button type="submit" status="primary">确定</vxe-button>
              <!-- <vxe-button type="submit" status="primary" @click="editEvent(formData)" v-else>确定</vxe-button> -->
              <vxe-button type="reset">取消</vxe-button>
            </template>
          </vxe-form-item>
        </vxe-form>
      </div>
    </vxe-modal>
    <vxe-modal
        v-model="isShowChooseAccount"
        width="800"
        height="600"
        resize
        remember
        title="选择客户"
    >
      <choose-account
          @choose="chooseAccountEvent"
          ref="chooseAccount"
      ></choose-account>
    </vxe-modal>
    <vxe-modal
        v-model="isShowBankAccountModal"
        width="900"
        height="600"
        resize
        remember
        :title="bankAccountModalTitle"
        :showHeader="false"
    >
      <bank-account
          @close="closeBankAccount"
          @choose="chooseBankAccount"
          :isShow="isShowBankAccountModal"
          ref="bankAccountModal"
      ></bank-account>
    </vxe-modal>
    <!-- <div class="search-filter">
      <vxe-modal
        class="timeModal"
        v-model="open"
        width="460"
        height="400"
        :show-footer="false"
        :showHeader="false"
      >
        <template v-slot>
          <DatePicker
            :open="open"
            confirm
            type="daterange"
            :split-panels="true"
            placeholder
            style="width: 432px"
            @on-change="handleChange"
            @on-clear="handleClear"
            @on-ok="handleOk"
          >
            <span class="date-slot"></span>
          </DatePicker>
        </template>
      </vxe-modal>
    </div> -->
  </div>
</template>

<script>
import $api from "@/apiProvider";
import $C from "@/consts/index";
import {searchTime, SEARCH_TIME} from "@/filters/time";
import moment from "moment";
import getAuthOrization from "@/mixin/getAuthOrization";
import {paymentFooter, showLoading, hideLoading} from "@/utils/util";
import openProcedureDetail from "@/mixin/viewOrderDetail";
import {isEmpty} from "@/utils/util";
import Account from "@/components/modal/Account";
import BankAccount from "@/components/modal/BalanceBankAccount";
import {formatMoney} from "@/filters/type";

const empties = [undefined, "", null, "null", {}, []];

export default {
  mixins: [getAuthOrization, openProcedureDetail],
  name: "FranchiseeList",
  components: {
    ChooseAccount: Account,
    BankAccount
  },
  props: {
    cate: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      searchLoading: false,
      queryAction: "",
      deleteAction: "",

      tableData: [],
      totalCounts: "",
      totalAmount: "",
      page: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      searchParams: {
        addTimeBegin: "",
        addTimeEnd: "",
      },
      title: '',
      timeVal: "",
      rangeTime: "time",
      open: false,
      // startTime: "",
      // endTime: "",
      // timeOptions: SEARCH_TIME.options,
      balanceTypeOptions: $C.BALANCE_TYPE.options,
      searchRecName: [],
      searchCompAccount: [],
      searchClientName: [],
      searchCompName: [],
      compAccountOptions: [],
      clientNameOptions: [],
      compNameOptions: [],
      balanceType: null,
      comName: '',
      // searchFormData: {
      //   balanceType: null,
      //   salesMan: null,
      //   clientName: null,
      //   compName: null,
      // },
      searchFormItems: [
        {
          align: "right",
          span: 12,
          titleAlign: "left",
          itemRender: {
            name: "$buttons",
            children: [
              {props: {type: "submit", content: "搜索", status: "primary"}},
              {props: {type: "reset", content: "重置"}},
            ],
          },
        },
      ],
      isShowAddBalance: false,
      formData: {
        type: null,
        companyName: null,
        initBalance: null,
        clientName: null,
        clientId: null,
        salesManName: null,
        salesManId: null,
        accountNum: null,
        bankName: null,
        initTime: null,
        ordersNum: null
      },
      formRules: {
        type: [{required: true, message: "请输入期初余额类型"}],
        companyName: [{required: true, message: "请选择所属公司"}],
        initBalance: [{required: true, message: "请输入期初余额"}],
        accountNum: [{required: true, message: "请选择开户"}],
        bankName: [{required: true, message: "请选择开户行"}],
        // identityType: [{ required: true, message: "请选择身份" }],
      },
      dicByParentData: [],
      type: null,
      isShowChooseAccount: false,
      tableColumn: [{field: "name", title: "姓名"}], // 表格数据列
      tableList: [], // 业务员列表
      filterName: null,
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        size: "mini",
      },
      isShowBankAccountModal: false,
      bankAccountModalTitle: "选择银行账户",
      ordersNum: null,
      ordersData: [],
      ordersColumns: [{field: "ordersNum", title: "订单号"}],
      ordersLoading: false,
      chooseOrderNum: false
    };
  },
  watch: {
    isShowAddBalance: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val) {
          this.resetFormData();
        }
      },
    },
  },
  mounted() {
    this.$bus.$on("期初余额管理2.0", () => {
      this.reset();
    });
    // this.startTime = moment().startOf("month").format("YYYY-MM-DD");
    // this.endTime = moment().endOf("day").format("YYYY-MM-DD");
    // 加盟商
    this.getList("", "compAccountOptions", "initBalance", "queryParamSalesMan", 5);//客户
    this.getList("", "clientNameOptions", "initBalance", "queryParamClientName", 6);
    this.getList("", "compNameOptions", "initBalance", "queryParamCompanyName", 7);
    this.getListData();
  },
  methods: {
    footerMethod({columns, data}) {
      // 底部合计
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return "合计";
          }
          if (["initBalance"].includes(column.property)) {
            return this.$utils.sum(data, column.property);
          }
          return null;
        }),
      ];
    },
    inputEvent(val) {
      this.chooseOrderNum = false;
      if (val && val !== '') {
        this.$nextTick(() => {
          this.$refs.ordersDown.showPanel();
          this.getOrdersData(val);
        })
      }
    },
    checkOrder() {
      if (!this.formData.ordersNum || !this.chooseOrderNum) {
        this.formData.ordersNum = '';
      }
    },
    cellClick({row}) {
      this.chooseOrderNum = true;
      this.formData.ordersNum = row.ordersNum;
      this.$refs.ordersDown.hidePanel();
    },
    async getOrdersData(val) {
      this.ordersLoading = true;
      let res = await $api.twoOrders.post("list", {
        page: 1,
        rows: 100,
        ordersNum: val
      });
      this.ordersLoading = false;
      if (res.status === 1) {
        this.ordersData = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    reset() {
      this.searchParams = {
        type: null
      };
      // this.startTime = "";
      // this.endTime = "";
      this.ordersNum = null;
      this.balanceType = null;
      this.searchRecName = [];
      this.searchCompAccount = [];
      this.searchClientName = [];
      this.searchCompName = [];
      this.tableData = [];
      this.getListData();
    },
    resetFormData() {
      if (this.type === 0) {
        this.formData = {
          type: null,
          companyName: null,
          initBalance: null,
          clientName: null,
          clientId: null,
          salesManName: null,
          salesManId: null,
          accountNum: null,
          bankName: null,
          initTime: null,
          ordersNum: null
        };
      }
    },
    CreateBalance(type = 0) {
      this.isShowAddBalance = true;
      this.title = '新建期初余额'
      this.type = type;
      this.getDicByParentList();
    },
    openEditView(row) {
      this.type = 1;
      this.isShowAddBalance = true;
      this.formData = Object.assign({}, row);
      this.title = '修改期初余额'
      this.getDicByParentList();
    },
    submitEvent() {
      this.type === 0 ? this.createNewBalance() : this.editBalance();
    },
    cancelEvent() {
      this.isShowAddBalance = false;
    },
    async createNewBalance() {
      let params = Object.assign({}, this.formData);
      if (params.initTime) {
        params.initTime = this.$utils.timestamp(params.initTime);
      }
      let res = await $api.initBalance.post("add", params);
      if (res.status === 1) {
        console.log(res);
        this.$XModal.message({message: "添加成功！"});
        this.isShowAddBalance = false;
        this.getListData();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async editBalance() {
      let params = Object.assign({}, this.formData);
      if (params.initTime) {
        params.initTime = this.$utils.timestamp(params.initTime);
      }
      let res = await $api.initBalance.post("update", params);
      if (res.status === 1) {
        console.log(res);
        this.$XModal.message({message: "修改成功！"});
        this.isShowAddBalance = false;
        this.getListData();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    commitDelete(id) {
      this.$XModal.confirm('您确定要删除吗？').then(type => {
        if (type === 'confirm') {
          this.deleteBalance(id);
        }
      })
    },
    async deleteBalance(id) {
      let res = await $api.initBalance.request('delete', {
        id: id
      });
      if (res.status === 1) {
        this.$Message.success('删除成功');
        this.getListData();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    changeType() {

    },
    clearType() {
    },
    selectCompanyName(e, scope) {
      this.comName = e.$event.currentTarget.innerText;
      this.$refs.xForm.updateStatus(scope);
    },
    async getDicByParentList() {
      let response = await $api.user.request("queryCompanyPermission");
      if (response.status == 1) {
        this.dicByParentData = response.data;
      }
    },
    openChooseAccount() {
      this.isShowChooseAccount = true;
      this.$refs.chooseAccount.init();
    },
    chooseAccountEvent(account, type) {
      console.log("chooseAccountEvent", account);
      this.formData.clientName =
          type === 1 ? account.compName : account.realName;
      this.formData.clientId = account.id;
      // this.currentRow[this.currentChooseColumn] = type === 1 ? account.compName : account.realName;
      this.isShowChooseAccount = false;
      // this.$refs.xTable.clearValidate(this.currentChooseColumn)
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    openBankAccountModal() {
      this.isShowBankAccountModal = true;
      this.$refs.bankAccountModal.init(1, 0, 'paymentsName', {companyName: this.comName});
    },
    closeBankAccount() {
      this.isShowBankAccountModal = false;
    },
    chooseBankAccount(bankAccount) {
      // console.log(bankAccount);
      this.formData.bankName = bankAccount.bankName;
      this.formData.accountNum = bankAccount.accountNum;
      this.isShowBankAccountModal = false;
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        // columnType: columnType,
        // moduleType: 1,
      };

      if (!isEmpty(query)) {
        params.keyword = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].get(path);
      this.searchLoading = false;
      if (res.status === 1) {
        this[options] = res.data;
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    init() {
      // this.getListData()
    },
    setSearchParams(searchParams) {
      this.searchParams = searchParams;
    },
    getSearchListKey() {
      if (
          this.balanceType === null &&
          this.searchCompAccount.length === 0 &&
          this.searchClientName.length === 0 &&
          this.searchCompName.length === 0
      ) {
        this.$XModal.alert({
          message: "请输入搜索条件",
          status: "error",
        });
        return;
      }
      // let obj = this.searchFormData;
      // let searchParams = {};
      // Object.keys(obj).forEach((key) => {
      //   if (obj[key] !== null) {
      //     searchParams[key] = obj[key];
      //   }
      // });
      // searchParams.recName = this.searchRecName;
      let searchParams = {};
      searchParams.type = this.balanceType;
      searchParams.salesManName = this.searchCompAccount;
      searchParams.clientName = this.searchClientName;
      searchParams.companyName = this.searchCompName;
      searchParams.ordersNum = this.ordersNum;
      // searchParams.flowNum = this.searchCompName;
      // searchParams.orderNum = this.searchCompName;
      // console.log(searchParams);
      // debugger
      this.searchParams = searchParams;
      this.getListData();
    },
    async getListData() {
      this.queryAction = "queryList";
      this.loading = true;
      // this.searchParams.beginDate =
      //   this.startTime === ""
      //     ? this.startTime
      //     : this.$utils.timestamp(this.startTime);
      // this.searchParams.endDate =
      //   this.endTime === ""
      //     ? this.endTime
      //     : this.$utils.timestamp(this.endTime) + 86399000;
      let params = empties.includes(this.searchParams) ? {} : this.searchParams;
      params.rows = 100000;
      let res = await $api.initBalance.post(this.queryAction, params);
      if (res.status == 1) {
        this.tableData = res.data.rows;
        // const curTableData = res.data.salemanAmount;
        // for (let i = 0 ; i < curTableData.length; i++) {
        //   let obj = curTableData[i]
        //   if (i === 0) {
        //     obj.balance = res.data.initBalance
        //   } else {
        //     obj.balance = (Number(curTableData[i-1].balance) + Number(curTableData[i].debitAmount) - Number(curTableData[i].creditAmount)).toFixed(2)
        //   }
        //   this.tableData.push(obj)
        // }
        this.loading = false;
      } else {
        if (empties.includes(res.message)) res.message = "接口异常";
        this.$XModal.message(res.message);
      }
    },
    pageChange(page) {
      this.page.currentPage = page.currentPage;
      this.page.pageSize = page.pageSize;
      this.getListData();
    },
    focusEvent(name) {
      let refs = this.$refs[name];
      this.tablePage.currentPage = 1;
      this.filterName = "";
      this.getUserList();
      refs.showPanel();
    },
    async cellClickEvent({row}) {
      this.formData.salesManName = row.name;
      this.formData.salesManId = row.id;
      this.$refs.xDown.hidePanel();
    },
    async getUserList() {
      let res = await $api.user.request("querySaleManagerList", {
        orderBy: 2,
        page: this.tablePage.currentPage,
        rows: this.tablePage.pageSize,
        userName: this.filterName,
      });
      if (res.status === 1) {
        this.tablePage.total = res.data.total;
        this.tableList = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    search() {
      this.tablePage.currentPage = 1;
      this.getUserList();
    },
    pageTableChange(e) {
      this.tablePage.currentPage = e.currentPage;
      this.tablePage.pageSize = e.pageSize;
      this.getUserList();
    },
    setSaleData(saleMan, salesManager) {
      this.saleMan = saleMan;
      this.salesManager = salesManager;
    },
  },
};
</script>
<style>
.finance-header .finance-span {
  display: inline-block;
  padding-right: 10px;
  margin-top: 10px;
}

.finance-span-time .line-icon {
  display: inline-block;
  width: 32px;
  text-align: center;
}

.finance-header label {
  display: inline-block;
  padding: 0 5px;
  /*color: #999;*/
}

.finance-header .vxe-input--inner,
.finance-header .ivu-input,
.finance-header .ivu-select-selection {
  border-radius: 5px;
  border: 1px solid #dcdee2;
  height: 34px;
  box-sizing: border-box;
}

.finance-header .ivu-select {
  width: 180px;
  height: 34px;
  overflow: hidden;
}

.finance-header .ivu-select-multiple .ivu-tag,
.finance-header .ivu-select-input {
  display: inline-block;
  float: left;
}

.finance-header .ivu-select-default.ivu-select-multiple .ivu-select-selection {
  max-height: 32px;
  border-radius: 5px;
}

.finance-header .ivu-select-prefix i {
  vertical-align: middle;
  position: absolute;
  right: 8px;
  top: 8px;
}

.search-filter .vxe-modal--wrapper.type--modal .vxe-modal--body,
.search-filter
.vxe-modal--wrapper.type--modal
.vxe-modal--body
.vxe-modal--content {
  overflow: hidden;
}

.search-filter .vxe-modal--wrapper.type--modal .vxe-modal--box {
  box-shadow: none;
  background: none;
  border: none;
}

.sel-text {
  height: 34px;
  line-height: 34px;
  width: 100%;
  font-size: 14px;
  border-radius: 4px;
  outline: 0;
  padding: 0 0.6em;
  color: #2d8cf0;
  border: 1px solid #dcdfe6;
  background-color: #fff;
  cursor: pointer;
}

.sel-people-dropdown {
  width: 400px;
  height: 300px;
  background-color: #fff;
  /* border: 1px solid #dcdfe6; */
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
}

.sel-people-dropdown .ivu-input-wrapper {
  position: absolute;
  right: 10px;
  top: 13px;
  z-index: 999;
}

.chainId-dropdown {
  width: 400px;
  height: 300px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
  position: relative;
}

.chainId-dropdown .ivu-input-wrapper {
  position: absolute;
  right: 10px;
  top: 8px;
  z-index: 999;
}

.chainId-dropdown .ivu-input {
  border-radius: 0;
}
</style>
